async function GetData(method, d, config, body) {
	//console.log("requesting get data", method, d, config, body);

	let result = null;

	await fetch("/api.aspx/" + method, {
		method: "POST",
		body: JSON.stringify({data: JSON.stringify(d)}),
		credentials: "same-origin",
		headers: {
			// "Content-Type": "text/plain",
			"Content-Type": "application/json",
			//"Content-Type": "application/x-www-form-urlencoded",
		},
	})
		.then(function (r) {
			// console.log("received data", method, d, r);
			result = r.json();
			// console.log("r1", result);
		})
		.catch((e) => {
			console.log("error", e);
		});
	//console.log("Done", method, d);

	return result;
}

async function APIFunction(apiname, data, config, body) {
	let result = null;
	await GetData(apiname, data, config, body).then((r) => {
		result = r;
	});
	return result;
}

export default APIFunction;
